<template>
  <div>
    <auth-header />
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner position-relative ">
        <!-- <div
          class="bg-out-auth position-absolute top-0 left-0 w-100 h-100"
        ></div> -->
        <b-card class="mb-0 position-relative overflow-hidden" no-body>
          <b-card-body style="z-index: 10" class="p-2">
            <b-link class="brand-logo my-3">
              <div class="d-flex align-items-center justify-content-center">
                <div style="height: 24px" class="ml-50 position-relative">
                  <div class="rounded logo-shadow position-absolute"></div>

                  <b-img
                    style="max-height: 24px"
                    :src="require('@/assets/images/fxlegends/logo2.png')"
                    fluid
                    alt="FX Legends"
                  />
                </div>
              </div>
            </b-link>

            <template v-if="$route.path.includes('forgot')">
              <h2 class="mb-1">Forgot Password? 🔒</h2>
              <b-card-text class="mb-2 h5">
                Enter your email and we'll send you instructions to reset your
                password
              </b-card-text>
            </template>
            <template v-else>
              <h2 class="mb-1">Reset Password 🔒</h2>
              <b-card-text class="mb-2 h5">
                Your new password must be different from previously used
                passwords
              </b-card-text>
            </template>

            <div class="w-100 d-flex" v-if="$route.path.includes('forgot')">
              <router-link
                tag="button"
                :class="[
                  'w-100 mr-25 btn py-1',
                  $route.path.includes('partner')
                    ? ' select-btn'
                    : 'unselect-btn border-secondary',
                ]"
                :to="{ name: 'auth-partner-forgot-password' }"
              >
                <span> I am a Partner </span>
              </router-link>

              <router-link
                tag="button"
                :class="[
                  'w-100 ml-25 py-1 btn',
                  $route.path.includes('user')
                    ? ' select-btn'
                    : 'unselect-btn border-secondary',
                ]"
                :to="{ name: 'auth-user-forgot-password' }"
              >
                <span> I am a User </span>
              </router-link>
            </div>
            <!-- form -->
            <router-view />

            <b-card-text class="text-center mt-2">
              <b-link :to="{ name: 'auth-user-login' }">
                <feather-icon icon="ChevronLeftIcon" /> Back to login
              </b-link>
            </b-card-text>
          </b-card-body>
          <!-- <div
            class="bg-in-auth position-absolute top-0 left-0 w-100 h-100"
          ></div> -->
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BLink,
  BCardText,
  BCardTitle,
  BButton,
  BButtonGroup,
  BImg,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import AuthHeader from "../auth-header/AuthHeader.vue";
export default {
  components: {
    BCard,
    BCardBody,
    BLink,
    BCardText,
    BCardTitle,
    BButton,
    BButtonGroup,
    BImg,
    AuthHeader,
  },
  directives: {
    Ripple,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
